// extracted by mini-css-extract-plugin
module.exports = {"body":"CatalogShowcase_body__wo8N7","title":"CatalogShowcase_title__36I_V"};